import { render, staticRenderFns } from "./paymentRecords.vue?vue&type=template&id=05e2b10e&scoped=true"
import script from "./paymentRecords.vue?vue&type=script&lang=js"
export * from "./paymentRecords.vue?vue&type=script&lang=js"
import style0 from "./paymentRecords.vue?vue&type=style&index=0&id=05e2b10e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e2b10e",
  null
  
)

export default component.exports